export default (contactList, storeContactList, mapped = true) => {
	const selectedcontacts = storeContactList.filter(
		({emailAddress, userId}) =>
			contactList.some((i) => i.emailAddress === emailAddress) || contactList.some((i) => i.contactId === userId)
	);
	return mapped ? selectedcontacts.map(({userId}) => userId) : selectedcontacts;
};
